import { gql } from '@apollo/client';
import MODEL_FRAGMENT from 'api/fragments/MODEL';
const GET_MODEL_SPECIFICATION = gql `
  ${MODEL_FRAGMENT}
  query GetModel($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        ...ModelFragment
      }
    }
  }
`;
export default GET_MODEL_SPECIFICATION;
